import { styled } from '@mui/material'

const BaseBackground = styled('img')({
  width: '100%',
  minHeight: '60vh',
  height: 'fit-content'
})

export default BaseBackground
